import { styled } from '@mui/material/styles';
import { Datagrid, DateField, FunctionField, TextField, useResourceContext, useTranslate } from 'react-admin';
import NotificationBox from '@/components/global/fields/NotificationBox.jsx';
import SimpleList from '@/components/global/list/SimpleList.jsx';
import { StatusField } from '@/components/accessKeys/fields/StatusField.jsx';

const StyledHistory = styled('div')(() => ({
    '& .RaDatagrid-tableWrapper': {
        maxWidth: '100px',
    },
}));

export const AccessKeyHistory = ({ accessKeyId }) => {
    const resource = useResourceContext();
    const translate = useTranslate();

    return (
        <StyledHistory>
            <SimpleList
                resource={`${resource}/${accessKeyId}/history`}
                sort={{ field: 'createdAt', order: 'DESC' }}
                empty={
                    <NotificationBox variant='info' className='large'>
                        {translate('resources.accessKey.labels.noHistory')}
                    </NotificationBox>
                }
            >
                <Datagrid bulkActionButtons={false}>
                    <TextField source='keyPreview' label={translate('resources.accessKey.labels.keyPreview')} />
                    <DateField label={translate('resources.accessKey.labels.validFrom')} source='validFrom' />
                    <DateField label={translate('resources.accessKey.labels.validUntil')} source='validUntil' />
                    <FunctionField label={translate('resources.accessKey.labels.status')} sortBy='status' render={record => <StatusField record={record} />} />
                    <FunctionField
                        label={translate('resources.accessKey.labels.revokedReason')}
                        sortBy='revokedReason'
                        render={record => translate(`selectOptions.accessKeyRevokedReasonChoices.${record.revokedReason}`)}
                    />
                    <DateField label={translate('resources.accessKey.labels.createdAt')} source='createdAt' showTime />
                    <FunctionField
                        label={translate('resources.accessKey.labels.createdBy')}
                        sortBy='user.lastName'
                        render={record => {
                            if (record.user) {
                                return `${record.user.firstName} ${record.user.lastName} (${record.user.email})`;
                            }

                            return translate('resources.accessKey.labels.createdByDefault');
                        }}
                    />
                </Datagrid>
            </SimpleList>
        </StyledHistory>
    );
};
